import { useMemo } from 'react'
import { 
  useGetContractTemplatesQuery} from '../../../../api/plamo-api'
import PlamoApiWithSaveNotifications from '../../util/with-save-notification'
import { ActionTablePath } from '../../action-table/action-table'
import { Breadcrumb } from 'antd'
import { HomeOutlined } from '@ant-design/icons'
import { useNavigate } from 'react-router-dom'
import { IconFileSignatureSolid } from '../../../../icon'

const { useDeleteContractTemplateWithSaveNotificationMutation } = PlamoApiWithSaveNotifications

function ContractTemplateListPage() {
  const [deleteContractTemplate, { isLoading: isDeletingContractTemplate }] = useDeleteContractTemplateWithSaveNotificationMutation()
  const navigate = useNavigate()

  const isLoading = isDeletingContractTemplate;
  
  const columns = useMemo(() => [
    {
      title: "Id",
      dataIndex: "id",
      sorter: true,
      filter: true,
      type: 'int',
    },
    {
      title: "Typ",
      dataIndex: "contractType",
      sorter: true,
      filter: true,
      render: value => value === 'employee' ? 'Mitarbeitervertrag' : 'Kundenvertrag'
    },
    {
      title: "Titel",
      dataIndex: "title",
      sorter: true,
      filter: true,
    },
  ], [])

  return (
    <div>
      <Breadcrumb
          style={{ marginBottom: "24px" }}
          items={[
            {
              onClick: () => navigate('/'),
              title: <HomeOutlined/>,
            },
            {
              title: (
                <>
                  <IconFileSignatureSolid />
                  <span>Vertragsvorlagen</span>
                </>
              ),
            },         
          ]}
        />
      <ActionTablePath
          isParentLoading={isLoading}
          buttonRow={{
            buttons: [
              {
                text: 'Neu',
                buttonType: 'primary',
                onClick: () => navigate('./new')
              },
            ]
          }}
          tableData={{
            defaultSortKey: 'id',
            columns,
            dataSource: {
              pageableQueryEndpoint: useGetContractTemplatesQuery,
              queryResultMapping: (result) => result?.items
            },
            actions: [
              {
                caption: 'Bearbeiten',
                onClick: (item) => navigate(`./${item.id}`)
              },
              {
                caption: 'Löschen',
                danger: true,
                onClick: (item) => deleteContractTemplate(item)
              }
            ]
          }}
        />
    </div>
  )
}

export default ContractTemplateListPage